import { render, staticRenderFns } from "./researchDialog.vue?vue&type=template&id=cbfb385c&scoped=true&"
import script from "./researchDialog.vue?vue&type=script&lang=js&"
export * from "./researchDialog.vue?vue&type=script&lang=js&"
import style0 from "./researchDialog.vue?vue&type=style&index=0&id=cbfb385c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfb385c",
  null
  
)

export default component.exports